import React from 'react';
import { BlogPostListBlock } from '../../_blocks/BlogPostList';
import { Widget as WidgetShape } from '../../types/api/Widget';
import { WidgetType } from '../../types/api/ElementType';
import { isNullOrUndefined } from '../../lib/typeGuards';
import { isEmptyBlock } from '../../types/api/Block';
import { Widget, WidgetHeader, WidgetHeading, WidgetTitle } from '../../_lib/components/Widget';
import { useSonTranslation } from '../../translation/useSonTranslation';

type BlogPostListWidget = WidgetShape<BlogPostListBlock, WidgetType.blogpostlist>;

export function BlogPostListWidget({ blocks, uuid }: BlogPostListWidget) {
  const { t } = useSonTranslation('Blogs');

  if (isNullOrUndefined(blocks[0]) || isEmptyBlock(blocks[0])) {
    return null;
  }
  return (
    <Widget isArticle isFrameless uuid={uuid} widgetType={WidgetType.blogpostlist}>
      <WidgetHeader invisible>
        <WidgetHeading hierarchy={2}>
          <WidgetTitle>{t('blogPostListWidgetTitle')}</WidgetTitle>
        </WidgetHeading>
      </WidgetHeader>
      <BlogPostListBlock {...blocks[0]} />
    </Widget>
  );
}
